import { ButtonERP, DropdownPrimeReact } from "@finanedi.es/storybook"
import { postCesionAceptar } from "api/Cesion.service"
import { GetCesionByFiltersDtoProps } from "api/DTOs/GetCesionByFiltersDto"
import { GetCesionByIdDtoProps } from "api/DTOs/GetCesionByIdDto"
import { useEnumFormasCobro } from "api/Enum.hook"
import { EstadoCesionType } from "api/Types/EstadoCesion"
import { ESTADO_CESION_ACEPTACION } from "api/Types/EstadoCesionAceptacion"
import { FORMA_DE_COBRO, FormaDeCobroType } from "api/Types/FormaDeCobro"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import notification from "common/utils/notification"
import { RESP_200 } from "constants/numbers"
import { withFormik } from "formik"
import { TFunction } from "i18next"
import { Dispatch } from "react"
import { Trans, useTranslation } from "react-i18next"
import { frontendDateFormat } from "utils/formatDate"
import * as Yup from "yup"
import "../VerificarCesionForm/style.scss"
import {
  OPTIONS_ESTADO_ACEPTACION,
  OPTIONS_PLAZO_PAGO,
  PLAZOS_VALUES,
  TIPO_CESION,
} from "./constant"

const AceptacionCesionForm = ({
  cesionData,
  rowData,
  onHide,
  values,
  setFieldValue,
  handleSubmit,
}: {
  cesionData: GetCesionByIdDtoProps | undefined
  rowData: GetCesionByFiltersDtoProps | undefined
  onHide: () => void
  values: {
    estado?: EstadoCesionType
    formaPago?: FormaDeCobroType
    plazoPago?: number | null
    observaciones?: string
  }
  setFieldValue: (
    field: string,
    value: EstadoCesionType | FormaDeCobroType | number | null | string,
    shouldValidate?: boolean
  ) => void
  handleSubmit: () => void
}) => {
  const { t } = useTranslation()

  const {
    activeCompany: { razonSocial },
  } = useUsuarioEmpresaActiva()

  const { formasCobro, formasCobroIsLoading } = useEnumFormasCobro()

  const relacionComercialText =
    cesionData?.tipo !== TIPO_CESION.FUTURO
      ? t("validaciones.modal.textFuturo")
      : t("validaciones.modal.textContrato", {
          fecha: cesionData?.fechaInicioContrato
            ? frontendDateFormat(new Date(cesionData?.fechaInicioContrato))
            : "",
          descripcion: cesionData?.descripcion,
          interpolation: { escapeValue: false },
        })

  return (
    <form onSubmit={handleSubmit}>
      <section className='tw-w-112'>
        <div className='tw-flex tw-flex-col'>
          <label
            htmlFor='estado'
            className=''
          >
            {t("validaciones.modal.statusCesion")}
          </label>
          <DropdownPrimeReact
            id='estado'
            optionLabel='label'
            optionValue='value'
            placeholder={`${t("validaciones.modal.statusCesionPlaceholder")}`}
            panelClassName='!tw-max-w-xl'
            z-index='50'
            options={OPTIONS_ESTADO_ACEPTACION(t)}
            value={values.estado}
            onChange={({ value }: { value: number }) => {
              setFieldValue("estado", value)
            }}
          />
        </div>

        {values?.estado === ESTADO_CESION_ACEPTACION.ACEPTADA && (
          <div className='tw-flex tw-flex-col'>
            <div className='mt-3 mb-3 input-group_container'>
              <div className='input_box'>
                <label
                  htmlFor='plazoPago'
                  className='text-labels'
                >
                  {t("validaciones.modal.timePago")}
                </label>

                <DropdownPrimeReact
                  id='plazoPago'
                  optionLabel='label'
                  optionValue='value'
                  z-index='50'
                  placeholder={`${t("validaciones.modal.timePagoPlaceholder")}`}
                  panelClassName='!tw-max-w-xl'
                  options={OPTIONS_PLAZO_PAGO(t)}
                  value={values.plazoPago}
                  onChange={({ value }: { value: number }) => {
                    setFieldValue("plazoPago", value)
                  }}
                />
              </div>
            </div>

            <div className='mt-3 mb-3 input-group_container'>
              <div className='input_box'>
                <label
                  htmlFor='formaPago'
                  className='text-labels'
                >
                  {t("validaciones.modal.methodPago")}
                </label>
                <DropdownPrimeReact
                  id='plazoPago'
                  optionLabel='description'
                  optionValue='id'
                  z-index='50'
                  placeholder={`${t(
                    "validaciones.modal.methodPagoPlaceholder"
                  )}`}
                  panelClassName='!tw-max-w-xl'
                  options={formasCobro}
                  loading={formasCobroIsLoading}
                  value={values.formaPago}
                  onChange={({ value }: { value: FormaDeCobroType }) => {
                    setFieldValue("formaPago", value)
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div className='mt-4'>
          {values?.estado ? (
            (values?.estado === ESTADO_CESION_ACEPTACION.ACEPTADA && (
              <Trans
                i18nKey='validaciones.modal.textAceptacion'
                components={[
                  <span
                    className='tw-font-medium tw-contents'
                    key='0'
                  />,
                ]}
                values={{
                  empresa: razonSocial,
                  cedente: rowData?.librador?.razonSocial,
                  cesionaria: cesionData?.empresaInternaRazonSocial,
                  plazo: values?.plazoPago,
                  formaPago:
                    values?.formaPago === FORMA_DE_COBRO.TRANSFERENCIA
                      ? `${t("validaciones.modal.typeTransferencia")} - ${
                          cesionData?.cuentaInternaIban
                        }`
                      : values?.formaPago === FORMA_DE_COBRO.PAGARE
                      ? `${t("validaciones.modal.typePagare")}`
                      : values?.formaPago === FORMA_DE_COBRO.CONFIRMING
                      ? `${t("validaciones.modal.typePagoDomiciliado")}`
                      : `${t("validaciones.modal.typeConfirming")}`,
                  relacionComercial: relacionComercialText,
                }}
                tOptions={{ interpolation: { escapeValue: false } }}
              />
            )) ||
            (values?.estado === ESTADO_CESION_ACEPTACION.RECHAZADA && (
              <Trans
                i18nKey='validaciones.modal.textDenegation'
                components={[
                  <span
                    className='tw-font-medium tw-contents'
                    key='0'
                  />,
                ]}
                values={{
                  empresa: razonSocial,
                  cedente: rowData?.librador?.razonSocial,
                  cesionaria: cesionData?.empresaInternaRazonSocial,
                }}
                tOptions={{ interpolation: { escapeValue: false } }}
              />
            ))
          ) : (
            <></>
          )}
        </div>

        <div className='departaments-modal__actions'>
          <ButtonERP
            customize={{
              size: "md",
              type: "white",
            }}
            type='button'
            label={`${t("validaciones.modal.cancel")}`}
            onClick={onHide}
          />

          {values?.estado ? (
            (values?.estado === ESTADO_CESION_ACEPTACION.ACEPTADA && (
              <ButtonERP
                customize={{
                  size: "md",
                  type: "secondary",
                }}
                type='submit'
                label={`${t("validaciones.modal.aceptLabel")}`}
              />
            )) ||
            (values?.estado === ESTADO_CESION_ACEPTACION.RECHAZADA && (
              <ButtonERP
                customize={{ size: "md", type: "danger" }}
                label={`${t("validaciones.modal.rejectLabel")}`}
                type='submit'
              />
            ))
          ) : (
            <></>
          )}
        </div>
      </section>
    </form>
  )
}

type FormValues = {
  estado?: EstadoCesionType
  formaPago?: FormaDeCobroType
  plazoPago?: number | null
}

type OuterProps = {
  cesionData: GetCesionByIdDtoProps | undefined
  rowData: GetCesionByFiltersDtoProps | undefined
  onHide: () => void
  setShowLoadingModal: Dispatch<React.SetStateAction<boolean>>
  fetchTableData: () => void
  t: TFunction
}

const NewAceptacionCesionForm = withFormik<OuterProps, FormValues>({
  validateOnChange: true,
  validateOnBlur: true,
  enableReinitialize: false,
  mapPropsToValues: () => ({
    estado: undefined,
    formaPago: FORMA_DE_COBRO.TRANSFERENCIA,
    plazoPago: 60,
  }),
  validationSchema: ({ t }: OuterProps) =>
    Yup.object().shape({
      estado: Yup.number().oneOf(
        Object.values(ESTADO_CESION_ACEPTACION),
        `${t("errors.selectedOption")}`
      ),
      observaciones: Yup.string().nullable(),
      formaPago: Yup.number().oneOf(
        Object.values(FORMA_DE_COBRO),
        `${t("errors.selectedOption")}`
      ),
      plazoPago: Yup.number().oneOf(
        Object.values(PLAZOS_VALUES),
        `${t("errors.selectedOption")}`
      ),
    }),
  handleSubmit: async (values, props) => {
    const { cesionData, setShowLoadingModal, fetchTableData, onHide, t } =
      props.props
    const { estado, formaPago, plazoPago } = values
    const dataCesion = {
      estado,
      formaPago,
      ...(estado === ESTADO_CESION_ACEPTACION.ACEPTADA
        ? { plazoPago, formaPago }
        : {}),
    }
    setShowLoadingModal(true)
    try {
      if (!cesionData?.id) return
      const resp = await postCesionAceptar(cesionData?.id, dataCesion)
      if (resp.status === RESP_200) {
        setShowLoadingModal(false)
        notification.success({
          body: `${t("validaciones.modal.msg.acceptCesion")}`,
        })
        fetchTableData()
      }
    } catch (error) {
      notification.warning({
        body: `${t("validaciones.modal.msg.warningCesion")}`,
      })
      setShowLoadingModal(false)
    } finally {
      onHide()
    }
  },
})(AceptacionCesionForm)

export default NewAceptacionCesionForm
